module.exports = __webpack_public_path__ + "static/media/support-clock.494182cf.svg";